import format from "date-fns/format";

const DATE_PICKER_FORMAT = "yyyy-MM-dd";

export const evalTemplate = (templateStr, object = {}) =>
  templateStr.replace(/\${(.*?)}/g, (_, g) => object[g]);

export const isString = str => typeof str === "string";

export const isEmpty = obj => {
  for (const prop in obj) {
    if (Object.hasOwn(obj, prop)) {
      return false;
    }
  }

  return true;
};

export function datePickerNow() {
  return format(new Date(), DATE_PICKER_FORMAT);
}

export function getChecklistItemLink(item, customerId) {
  if (item.type === "EVD_CURRENT") {
    return "/customers/" + customerId + "/checklist/" + item.id;
  } else if (item.type === "EVD_HISTORICAL") {
    return "/customers/" + customerId + "/detail#" + item.configId;
  } else if (item.type === "POM") {
    const routeParams = { customerId: customerId, checklistItemId: item.id };
    if (item.completionStatus.name === "COMPLETE") {
      return {
        name: "proofOfMonitoringSubmission",
        params: routeParams
      };
    } else {
      return {
        name: "incompleteProofOfMonitoringRedirector",
        params: routeParams
      };
    }
  } else if (item.type === "W9") {
    return {
      name: "account",
      params: {
        initialTab: "w9",
        initialTabProps: { initialNavigation: "table" }
      }
    };
  } else if (item.type === "ACCOUNT_BUSINESS_INFO") {
    return {
      name: "account",
      params: {
        initialTab: "company",
        initialTabProps: { startInEditMode: true }
      }
    };
  } else {
    console.error("Unexpected checklistitem type ", item.type);
  }
}

export function datePickerToDisplay(datePickerDate) {
  if (!datePickerDate || datePickerDate.length < 8) return null;

  if (
    datePickerDate[4] != "-" ||
    (datePickerDate[7] != "-" && datePickerDate[6] != "-")
  )
    return null;

  let oldDate = datePickerDate.split("-");
  let year = oldDate[0];
  let month = oldDate[1];
  let day = oldDate[2];

  return `${month}/${day}/${year}`;
}

export const removeSuffix = str => str.replace(/;jsessionid=.+/i, "");
